import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DevicesConfig } from "../actions/apiActions";
import { formattedDevicesConfigs, formattedSamplesConfigs, ensureCommunicationDiagnostic, WaitingTime } from "../helpers/utils";

//DEFAULT STATE
export const devicesConfigsDefaultState = {
  settingsConfig: null,
  reportsConfig: null,
  entries: [],
  sampleEntries: [],
  devicesConfigs: [],
  graphicsConfigs: [],
  samplesConfigs: [], // SWAS
  deviceConfigsRaw: [],
  listViewConfigs: [],
};

// Thunk functions
export const fetchDevicesConfigs = createAsyncThunk("devicesConfigs/fetchDevicesConfigs", async (data, thunk) => {
  const { systemConfig, systemId, isSensor, customerId, file, url } = data;
  const params = {
    customerId: customerId ? customerId : systemConfig.CUSTOMER_ID,
    deviceId: systemId !== "edge" ? systemId : systemConfig.DEVICE_ID,
    file: file ? file : systemConfig.CONFIG_FILE,
    isSensor: isSensor ? isSensor : false,
  };
  const response = await DevicesConfig.get(url ? url : systemConfig.CONFIGURATION_URL, params, {
    timeout: WaitingTime,
  });
  return { response, systemId };
});

export const fetchDevicesConfigsRaw = createAsyncThunk("devicesConfigs/fetchDevicesConfigsRaw", async (data, thunk) => {
  console.log, log("fetchDevicesConfigsRaw data", data);
  const { systemId, isSensor, customerId, file, url } = data;
  const payload = {
    customerId: customerId,
    deviceId: systemId,
    file: file,
    isSensor: isSensor ? isSensor : false,
  };
  const response = await DevicesConfig.get(url, payload);
  return { response, systemId };
});

const devicesConfigsSlice = createSlice({
  name: "devicesConfigs",
  initialState: devicesConfigsDefaultState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDevicesConfigs.fulfilled, (state, action) => {
        console.log("fetchDevicesConfigs action", action);
        const { deviceConfigs, settings, reports, graphics, samples, listView } = action.payload.response;
        const devices = ensureCommunicationDiagnostic(deviceConfigs.devices);
        state.entries = devices;
        state.sampleEntries = samples;
        state.settingsConfig = settings;
        state.reportsConfig = reports;
        state.devicesConfigs = formattedDevicesConfigs(devices);
        state.graphicsConfigs = graphics;
        state.samplesConfigs = formattedSamplesConfigs(samples);
        state.listViewConfigs = listView;
      })
      .addCase(fetchDevicesConfigsRaw.fulfilled, (state, action) => {
        console.log("fetchDevicesConfigsRaw action", action);
        const { deviceConfigs } = action.payload.response;
        state.deviceConfigsRaw = deviceConfigs.devices;
      });
  },
});

export const { } = devicesConfigsSlice.actions;

export default devicesConfigsSlice.reducer;
